import * as actionTypes from './actionTypes'

export const fetchTransactionalDetails = payload => ({
  type: actionTypes.fetchTransactionDataType,
  payload
});
export const fetchTransactionalTabDetails = payload => ({
  type: actionTypes.fetchTransactionTabDataType,
  payload
});
export const filterGridData = payload => ({
  type: actionTypes.filterGridDataType,
  payload
})
export const filterSort = payload => ({
  type: actionTypes.filterSortType,
  payload
})

export const radioValueUpdate = (payload) => ({
  type: actionTypes.radioChangeType,
  payload,
})

export const tabChangerHandler = (payload) => ({
  type: actionTypes.tabChangeType,
  payload,
})

export const filterDataPrint = (payload) => ({
  type: actionTypes.filterDataPrintType,
  payload,
})

export const fetchOtherTransactionDetails = (payload) => ({
  type: actionTypes.fetchOtherTransactionType,
  payload,
})

export const clearOtherTransactionDetails = (payload) => ({
  type: actionTypes.clearOtherTransactionType,
  payload,
})

export const exportTxnData = (payload) => ({
  type: actionTypes.exportTxnDataType,
  payload
})
